import { DeviceTypes } from 'domain/api/graphql/generated';
import { CompanyTagType } from 'domain/company/types';

type ISourcefileType = {
  extension: string;
};
export interface IVideoMediafile {
  id?: string | null;
  order?: number | null;
  title?: string | null;
  previewUrl?: string | null;
  playDuration?: number | null;
  duration?: number | null;
  uploading?: boolean;
  isCopy?: boolean;
  type?: number | null;

  sourcefiles?: ISourcefileType[];

  mediafile?: {
    id: string;
    sourcefiles?: ISourcefileType[];
    duration?: number | null;
    uri?: string;
    type?: number | null;
  };
}

export interface IVideoStreamEmenuMediafile {
  id: string;
  emenuMediafileId: string;
  order: number;
  playDuration: number;
  playCount: number;
  title?: string | null;
  generationDuration?: number | null;
}

export type IVideoStreamItem =
  | (IDraggableVideoMediafile & { itemType: 'video' })
  | (IVideoStreamEmenuMediafile & { itemType: 'emenu' });

export interface IVideoStreamShort {
  id?: string;
  title?: string | null;
  description?: string | null;
  videoMediafiles?: IVideoMediafile[];
  emenuMediafiles?: IVideoStreamEmenuMediafile[];
  isDefault?: boolean;
  isGroupSlave: boolean;
  devicesGroup?: {
    id: string;
    title: string;
    isValid: boolean;
    masterVideoStream?: { id?: string | number } | null;
    validationError?: string | null;
  } | null;
}

export type VideoStreamBindModalProps = {
  selectedPoints: PointsListDataItem[];
  isDenyCreatePoint: boolean;
  selectedPoint?: SelectedPoint;
  videoStreamId?: string;
  setCurrentSelectedPointPoint?: (point?: SelectedPoint) => void;
};

export type PointsListDataItem = {
  id: string;
  device?: {
    id: string;
    requiredVersionUrl?: string | null;
    type: DeviceTypes;
    supportedFeatures: (string | null)[];
  } | null;
  isVideoDemo?: boolean;
};

export interface IDraggableVideoMediafile extends IVideoMediafile {
  id: string;
}

export enum VideoStreamFlow {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export type PointsListCheckboxGroupPointType = {
  id: string;
  title?: string;
  address?: string;

  description?: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  tags?: CompanyTagType[] | null;
};

export interface SelectedPoint {
  pointId: string;
  pointAddress?: string;
}

export interface IVideoStreamTag {
  id: string;
  title: string;
}
